import { notify } from 'src/clients/ApiService';
import {
  LatestReleaseDismissData,
  LatestReleaseDismissInput,
} from 'src/constants';
import { ApiMethods, ApiTags } from 'src/services/api/appApi';

import { appAPI } from '.';

const latestReleaseApi = appAPI.injectEndpoints({
  endpoints: (build) => ({
    getDismissedLatestRelease: build.query<LatestReleaseDismissData, null>({
      query: () => ({
        path: `/latest-releases/`,
        method: ApiMethods.get,
        options: {},
      }),
      providesTags: [ApiTags.latest_releases],
    }),
    updateLatestReleaseDismissal: build.mutation<
      LatestReleaseDismissData,
      LatestReleaseDismissInput
    >({
      query: (body) => ({
        path: `/latest-releases/dismiss`,
        method: ApiMethods.post,
        options: {
          body,
        },
      }),
      async onQueryStarted({ structFields }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          latestReleaseApi.util.updateQueryData(
            'getDismissedLatestRelease',
            null,
            (draft) => {
              const currentAt = draft.structFields.latest_release_dismissed_at;
              const nextAt = structFields.latest_release_dismissed_at;
              // Mirror the server: only an undo may move the dismissal back.
              if (
                !structFields.restore &&
                currentAt !== undefined &&
                (nextAt === undefined || nextAt < currentAt)
              ) {
                return;
              }
              draft.structFields.latest_release_dismissed =
                structFields.latest_release_dismissed;
              draft.structFields.latest_release_dismissed_at = nextAt;
            },
          ),
        );
        try {
          await queryFulfilled;
        } catch (error) {
          patchResult.undo();
          notify({
            status: 'error',
            errorMessage: 'This latest release card could not be deleted.',
            error,
            dispatch,
          });
        }
      },
    }),
  }),
});

export const {
  useUpdateLatestReleaseDismissalMutation,
  useGetDismissedLatestReleaseQuery,
} = latestReleaseApi;
